import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import BannerWithCTA from '../../../components/BannerWithCta';
import MiniCardWithCta from '../../../components/CardWithCta';
import connectIcon from '../../../assets/MiniCard/icon-connect.svg';
import sendSmsIcon from '../../../assets/MiniCard/icon-send-sms.svg';
import businessIcon from '../../../assets/MiniCard/icon-business.svg';
import securityIcon from '../../../assets/MiniCard/icon-security.svg';
import reportIcon from '../../../assets/MiniCard/icon-report.svg';
import supportIcon from '../../../assets/MiniCard/icon-support.svg';

const EmailAPI = (props) => {
  const getGreetingTime = (momentDate) => {
    let greeting = null;

    if (!momentDate || !momentDate.isValid()) {
      return;
    }

    const split_afternoon = 12;
    const split_evening = 17;
    const currentHour = parseFloat(momentDate.format('HH'));

    if (currentHour >= split_afternoon && currentHour <= split_evening) {
      greeting = 'afternoon';
    } else if (currentHour >= split_evening) {
      greeting = 'evening';
    } else {
      greeting = 'morning';
    }

    return greeting;
  };

  return (
    <div className="EmailAPIPage">
      <BannerWithCTA
        title="Get started with Email API"
        description={
          <>
            Welcome to elfo Email-to-SMS API Services! Send SMS messages globally and reach your
            customers
            <br />
            by combining the most reliable elfoA2P SMS and email automation.
          </>
        }
        // description="Welcome to elfo Email-to-SMS API Services! Send SMS messages globally and reach your customers by combining the most reliable elfoA2P SMS and email automation."
        btnText="Request Access"
        btnUrl="/dashboard/contact-our-expert?product=email"
      />
      <div className="mini-card-wrapper">
        <MiniCardWithCta
          type={2}
          iconSrc={connectIcon}
          title="Connect elfoA2P with Email Automation"
          description="Boost sales and marketing with seamless A2P SMS and email automation integration, driving personalized customer engagement."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={sendSmsIcon}
          title="Send SMS to One or Many Users"
          description="Connect email tool with A2P SMS Gateway to send personalised notifications to your users or send targeted marketing."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={businessIcon}
          title="No Technical Skills Required"
          description="Our email to SMS gateway is very easy to implement in email automation tool without any technical skills required."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={securityIcon}
          title="Highest level of security and privacy"
          description="Our Email-to-SMS API ensures GDPR compliance, eliminating the need for sensitive data uploads or transfers."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={reportIcon}
          title="Reporting & Analytics"
          description="Get actionable insights with detailed reports on customer support performance, response rates, and more."
        />
        <MiniCardWithCta
          type={2}
          iconSrc={supportIcon}
          title="Dedicated Support"
          description="Experience personalized support from elfo's expert business consultants and technical teams, ensuring your digital customer experiences thrive."
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    user: auth.user,
  };
};

export default connect(mapStateToProps, null)(EmailAPI);
